import type { ScreenInteractionContext } from './platform/analytics/interactionAnalytics'
import { OperatorInlineImage } from './OperatorInlineImage'

type GalleryItem = {
  caption: string
  ref: { id: string; fileExt?: string }
}

type Props = {
  operatorId: string
  items: GalleryItem[]
  analytics?: ScreenInteractionContext
}

/** Catalog-backed inline images with captions (line markers, etc.). */
export function OperatorImageGallery({ operatorId, items, analytics }: Props) {
  return (
    <div className="operator-image-gallery">
      {items.map((item) => (
        <figure key={item.ref.id} className="operator-image-gallery-item">
          <OperatorInlineImage
            operatorId={operatorId}
            fileId={item.ref.id}
            fileExt={item.ref.fileExt}
            alt={item.caption}
            className="operator-image-gallery-image"
            zoomable
            analytics={analytics}
          />
          {item.caption ? <figcaption className="operator-image-gallery-caption">{item.caption}</figcaption> : null}
        </figure>
      ))}
    </div>
  )
}
